<script setup lang="ts">
  import FormElementSelector from '@/components/form-wizard/FormElementSelector.vue'
  import FormPreviewer from '@/components/form-wizard/FormPreviewer.vue'
  import FieldConfigurator from '@/components/form-wizard/FieldConfigurator.vue'
  import { ToastMessage } from '@logistiek-zonder-papier/lzp-library'
  import { ref, watch } from 'vue'
  import { useFlowConfigStore } from '@/store/flow-config.store'
  import { useRoute } from 'vue-router'
  import TopBar from '@/components/TopBar.vue'

  const route = useRoute()

  defineOptions({ inheritAttrs: false })

  const flowConfigStore = useFlowConfigStore()
  const selectedFieldId = ref<string | undefined>(undefined)
  const selectedPageId = ref<string | undefined>(undefined)

  watch(
    () => route.params,
    async ({ subAppId, type }) => {
      if (!subAppId || Array.isArray(subAppId)) return
      if (!type || Array.isArray(type)) return

      if (flowConfigStore.config) return

      await flowConfigStore.getFlowConfig(subAppId, type)
    },
    { immediate: true }
  )
</script>

<template>
  <TopBar />
  <section class="form-wizard">
    <FormElementSelector v-model:selectedFieldId="selectedFieldId" />
    <FormPreviewer
      :currentPage="flowConfigStore.currentPage"
      v-model:selectedFieldId="selectedFieldId"
      v-model:selectedPageId="selectedPageId"
    />
    <FieldConfigurator
      :currentPage="flowConfigStore.currentPage"
      v-model:selectedFieldId="selectedFieldId"
      v-model:selectedPageId="selectedPageId"
    />
    <ToastMessage />
  </section>
</template>

<style scoped>
  .form-wizard {
    display: flex;
    height: 100%;
  }
</style>
